import moment from "moment";
import React, { Component } from "react";
import { SLA_FILTERS, StatusMapping, STATUS_CODE_MAP, USER, KOTAK_ERID } from "../../../constants/insurance/constant";
import Container from '@mui/material/Container';
import { AppointmentDetails, checkSlaTime } from "../../../services/insurance/common";
import Alert from '@mui/material/Alert';
import AppointmentConfirmedTable from "./appointments-data";
import AlertTitle from '@mui/material/AlertTitle';
import { getAppointmentDate, getAppointmentTime, getCorrectDateFormat } from "../../../services/insurance/common";

(function() {
    const navEntries = performance.getEntriesByType('navigation');
    if (navEntries.length > 0) {
        const navigationType = navEntries[0].type;
        if (navigationType === 'reload') {
            let pgDetail = JSON.parse(localStorage.getItem("pageTracking"));
            let searchObject = JSON.parse(localStorage.getItem("searchObject"));
            if(searchObject?.isSearch)searchObject.isSearch = false;
            if(pgDetail?.endTime) pgDetail.endTime = moment().toISOString();
            if(pgDetail?.endTime) pgDetail.startTime = moment().subtract(1, "month").toISOString();
            localStorage.setItem('pageTracking', JSON.stringify(pgDetail));
            localStorage.setItem("searchObject", JSON.stringify(searchObject));
        }
    }
})();

class AppointmentConfirmedProvider extends Component {
  constructor(props) {
    let pgDetail = JSON.parse(localStorage.getItem("pageTracking"));
    super(props);
    this.state = {
      requests: [],
      rows: [],
      pageNo: this.getPageNo(this.props.match.params.status, true),
      messageAPI: "",
      startDate: moment().subtract(1, "month").toISOString(),
      endDate: moment().toISOString(),
      state: this.props.location.state,
      searchAppointment: this.props.searchAppointment,
      searchAPIValues: this.props.searchAPIValues,
      status: this.props.match.params.status
        ? this.props.match.params.status
        : undefined,
      statusId: this.assignStatusId(this.props.match.params.status),
      action: "confirm",
      slaBreachType: null,
      totalRows: null,
      isMobileView: false,
    };
    this.setIsMobileView = this.setIsMobileView.bind(this);
    this.onChangePageAppointment = this.onChangePageAppointment.bind(this);
    this.callAppointmentDetails = this.callAppointmentDetails.bind(this);
  }

  setIsMobileView(val) {
    this.setState({ ...this.state, isMobileView: val });
  }

  getPageNo(status, val = false) {
    if (localStorage.getItem("req")) {
      if (window.location.hash === localStorage.getItem("req"))
        return JSON.parse(localStorage.getItem("pageTracking")).page;
    }
    else {
      let pageNo = null;
      if (localStorage.getItem("pageTracking")) {
        let pageDetails = JSON.parse(localStorage.getItem("pageTracking"));
        if (val)
          pageNo = 1;
        else
          pageNo = pageDetails.page;
      } else {
        pageNo = 1;
      }
      return pageNo;
    }
  }
  componentDidMount() {
    if (window.location.hash === localStorage.getItem("req")) {
      let pgDetail = JSON.parse(localStorage.getItem("pageTracking"))
      this.state = {
        ...this.state,
        pageNo: pgDetail.page,
        startDate: pgDetail.startTime,
        endDate: pgDetail.endTime,
        totalRows: pgDetail.totalRows
      };
    }
    localStorage.removeItem("req");

    if (!localStorage.getItem('access_token')) {
      this.props.history.push('./login')
    } else if (localStorage.getItem('roleName') == 'insureragent') {
      this.props.history.push('/insureragent/appointments/esalesqueue')
    } else {
      USER.user = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")) : null;
      if (this.state.state) {
        this.setState({
          ...this.state,
          requests: this.props.location.state.requests,
          totalRows: this.props.location.state.totalRows,
          status: this.props.match.params.status,
          messageAPI: '',
          statusId: this.assignStatusId(this.props.match.params.status),
        }, () => {
          this.setRowsOfTable(1)
        })
      } else {
        this.assignStatusId()
        this.callAppointmentDetails(null, this.state.pageNo, this.state.startDate, this.state.endDate);
      }
    }
  }

  componentDidUpdate(prevProps) {


    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ ...this.state, pageNo: 1, totalRows: null }, () => {
        let pgno = JSON.parse(localStorage.getItem("pageTracking"));
        if (pgno) {
          pgno.page = 1;
          localStorage.setItem("pageTracking", JSON.stringify(pgno))
        }
        this.setRowsOfTable(1)
      })
    }
    if ((this.props.searchAPIValues !== prevProps.searchAPIValues)) {
      this.setState({
        ...this.state,
        requests: this.props.searchAPIValues.requests,
        messageAPI: '',
        totalRows: this.props.searchAPIValues.totalRows,
        status: this.props.match.params.status,
        slaBreachType: null,
        statusId: this.assignStatusId(this.props.match.params.status),
        searchAppointment: this.props.searchAppointment,
      }, () => {
        this.setRowsOfTable(1)
      });
    }

    if (this.props.match.params.status !== this.state.status && this.props.location.state === undefined) {
      let obj = JSON.parse(localStorage.getItem("pageTracking"))

      this.setState({
        ...this.state,
        startDate: (obj && obj.startTime) ? obj.startTime : "",
        endDate: (obj && obj.endTime) ? obj.endTime : "",
        status: this.props.match.params.status,
        searchAppointment: null,
        slaBreachType: (obj && obj.sla) ? SLA_FILTERS[this.props.match.params.status === 'confirmed' ? 'Confirmed Appointments' : 'New Appointments'] : null,
        statusId: this.assignStatusId(this.props.match.params.status)
      }, () => {
        this.callAppointmentDetails(null, this.getPageNo(this.props.match.params.status), this.state.startDate, this.state.endDate, this.state.statusId, this.state.slaBreachType)
      });
    }

    if (this.props.match.params.status !== this.state.status && this.props.location.state && this.props.location.state !== this.state.state) {
      this.setState({
        ...this.state,
        requests: this.props.location.state.requests,
        messageAPI: '',
        totalRows: this.props.location.state.totalRows,
        status: this.props.match.params.status,
        searchAppointment: null,
        slaBreachType: null,
        statusId: this.assignStatusId(this.props.match.params.status),
      }, () => {
        this.setRowsOfTable(1)
      })
    }
    if (this.props.selectedProviders.length !== prevProps.selectedProviders.length) {
      this.callAppointmentDetails(null, 1, this.state.startDate, this.state.endDate, this.state.statusId, this.state.slaBreachType, true)
    }
  }

  assignStatusId(status) {
    switch (status) {
      case 'confirmed': return STATUS_CODE_MAP["Confirmed by Medical Center"];
      default: return STATUS_CODE_MAP["New Appointment Request"];
    }
  }

  assignPageToDashboard(status, value) {
    switch (status) {
      case 'confirmed': this.setPageTrack(2, value); break;
      default: this.setPageTrack(1, value); break;
    }
  }

  createData(requestid, employeeId, employeeMailID, contactNo, customername, corporatename, appointmentdetails, packagedetails, appointmentdate, appointmentdatetime, createdDate, createdDateTime, additionals, visitType, dateTime, rowData, isHNI) {
    let breachTime = null;
    if (this.state.status === "confirmed") {
      breachTime = checkSlaTime(rowData.formattedfulfillmentDate, 4)
    } else {
      breachTime = checkSlaTime(rowData.createdOn, 12)
    }
    return {
      requestid,
      employeeId,
      employeeMailID,
      contactNo,
      customername,
      corporatename,
      appointmentdetails,
      packagedetails,
      appointmentdate,
      appointmentdatetime,
      createdDate,
      createdDateTime,
      additionals,
      visitType,
      dateTime,
      rowData,
      isHNI,
      breachTime: breachTime,
    };
  }

  getHNI(priorityName) {
    return priorityName.toUpperCase().indexOf("HNI") > -1 ? true : false;
  }

  getStatusText = (statusId) => {
    let status = ""
    StatusMapping.map(ele => { if (ele.statusId === statusId) status = ele.StatusNew });
    return status
  }

  setRowsOfTable = () => {
    let rows = [];
    if (this.state.requests && this.state.requests !== '' && this.state.requests.length > 0) {
      let tuples = this.state.requests;
      if (tuples) {
        tuples.map((elem) => {
          if (elem !== undefined) {
            rows.push(this.createData(elem.customerDetails.requestID,
              elem.customerDetails.empId,
              elem.customerDetails.email,
              elem.appointmentDetails.visitType === "Home_Visit" ? elem.customerDetails.phonePrimary :
                elem.customerDetails.phonePrimary,
              elem.customerDetails.name,
              elem.customerDetails.corporateName,
              KOTAK_ERID.includes(elem.customerDetails.corporateId) ? elem.labeling.currentStatusText : this.getStatusText(elem.labeling.currentStatusId),
              elem.appointmentDetails.productName,
              getAppointmentDate(elem.appointmentDetails.fulfillmentDate),
              getAppointmentTime(elem.appointmentDetails.fulfillmentDate),
              getAppointmentDate(elem.appointmentDetails.createdDate),
              getAppointmentTime(elem.appointmentDetails.createdDate),
              elem.appointmentDetails.additionals,
              elem.appointmentDetails.visitType,
              getCorrectDateFormat(elem.appointmentDetails.fulfillmentDate),
              elem,
              this.getHNI(elem.labeling.priority)))
          }
          return true;
        })
      }
      else {
        return false;
      }

    }
    this.setState({
      ...this.state,
      rows: rows,
      pageNo: this.getPageNo(this.state.status)
    })
  }

  onChangeStartDate = (value) => {
    this.setState({
      ...this.state,
      startDate: value
    })
  }
  onChangeEndDate = (value) => {
    this.setState({
      ...this.state,
      endDate: value
    })
  }

  setPageTrack(id, value) {
    if (localStorage.getItem("pageTracking")) {
      let dashboards = JSON.parse(localStorage.getItem("pageTracking"));
      if (dashboards.id === id) {
        dashboards.page = value;
      }
      localStorage.setItem('pageTracking', JSON.stringify(dashboards));
    }
  }

  onDateSearch = (value) => {
    if (value) {
      this.assignPageToDashboard(this.state.status, 1)
      this.setState({
        ...this.state,
        pageNo: this.getPageNo(this.state.status)
      }, () => {
        let pgTrack = JSON.parse(localStorage.getItem("pageTracking"))
        let searchObject = JSON.parse(localStorage.getItem("searchObject"))?.isSearch ? JSON.parse(localStorage.getItem("searchObject")) : null;
        this.callAppointmentDetails(searchObject, this.state.pageNo, pgTrack && pgTrack.startTime ? pgTrack.startTime : this.state.startDate, pgTrack && pgTrack.endTime ? pgTrack.endTime : this.state.endDate)
      })
    }
  }

  onChangePageAppointment = (value) => {
    const that = this;
    if (value != null) {
      if (value) {
        this.assignPageToDashboard(this.state.status, value)
        this.setState({
          ...this.state,
          rows: [],
          pageNo: that.getPageNo(this.state.status),
        }, () => {
          let pgTrack = JSON.parse(localStorage.getItem("pageTracking"));
          let searchObject = JSON.parse(localStorage.getItem("searchObject"))?.isSearch ? JSON.parse(localStorage.getItem("searchObject")) : null;
          this.callAppointmentDetails(searchObject, this.state.pageNo, pgTrack && pgTrack.startTime ? pgTrack.startTime : this.state.startDate, pgTrack && pgTrack.endTime ? pgTrack.endTime : this.state.endDate, this.state.statusId)
        })
      }
    }
  }


  showErrorMessage() {
    return (this.state.messageAPI !== '' ? <Alert severity="error">
      <AlertTitle className="uppercase">{this.state.messageAPI}</AlertTitle>
      <strong>Please Logout and try again !</strong>
    </Alert> : '')
  }

  callAppointmentDetails(searchAppointment, pageNo, firstDate, endDate, statusId, slaBreachType) {
    const that = this;
    let pgDetail = JSON.parse(localStorage.getItem("pageTracking"));
    AppointmentDetails(searchAppointment, pageNo, firstDate, endDate, (firstDate || endDate) ? "RequestFulfillmentDate" : "NA").then(data => {
      if (data && data.errorStatus && data.errorStatus !== 200 && data.errorResponse && data.errorResponse !== undefined) {
        that.setState({
          messageAPI: data && data.errorResponse && data.errorResponse.data && data.errorResponse.data.responseStatus && data.errorResponse.data.responseStatus.message ? data.errorResponse.data.responseStatus.message : ''
        })
      }
      else {
        that.setState((state) => ({
          requests: data && data.activerequests && data.activerequests.appointmentList ? data.activerequests.appointmentList : [],
          messageAPI: '',
          totalRows: data && data.activerequests && data.activerequests.totalActiveRequest ? data.activerequests.totalActiveRequest : null,
          // totalRows: state && state.totalRows? state.totalRows:data.activerequests.totalActiveRequest,
        }), () => {
          let pgDetail = JSON.parse(localStorage.getItem("pageTracking"));
          // pgDetail.totalRows = this.state && this.state.totalRows? this.state.totalRows:data.activerequests.totalActiveRequest;
          pgDetail.totalRows = data && data.activerequests && data.activerequests.totalActiveRequest ? data.activerequests.totalActiveRequest : null;
          localStorage.setItem("pageTracking", JSON.stringify(pgDetail));
          that.setRowsOfTable(pageNo)
        });
      }
    })
  }

  render() {
    return (
      <Container maxWidth="xlg" className={this.state.isMobileView ? "pt-3 appointment-container-xs pd-xs-0" : "pt-3"}>
        {this.showErrorMessage()}
        <AppointmentConfirmedTable
          status={this.state.status}
          pageNo={this.state.pageNo}
          totalRows={this.state.totalRows || 0}
          rows={this.state.rows || []} refreshData={() => this.callAppointmentDetails(null, this.state.pageNo, this.state.startDate, this.state.endDate, this.state.statusId, this.state.slaBreachType)}
          onChangePage={(event) => this.onChangePageAppointment(event)} onChangeStartDate={(event) => this.onChangeStartDate(event)}
          onChangeEndDate={(event) => this.onChangeEndDate(event)}
          action={this.state.action}
          onDateSearch={(event) => this.onDateSearch(event)}
          loadCasesOnFilters={(event) => this.onChangeSLAFilters(event)}
          slaBreachType={this.state.slaBreachType}
          searchAppointment={this.state.searchAppointment}
          setIsMobileView={this.setIsMobileView}
          isMobileView={this.state.isMobileView}
        >
        </AppointmentConfirmedTable>
      </Container >
    )
  }
}

export default AppointmentConfirmedProvider;